function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__a",
  x1: "19.675%",
  x2: "58.848%",
  y1: "23.146%",
  y2: "57.822%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#5C72B4",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__b",
  x1: "46.997%",
  x2: "50.385%",
  y1: "-2.698%",
  y2: "66.471%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "2%",
  stopColor: "#1E0D43"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "98%",
  stopColor: "#513292"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__c",
  x1: "22.048%",
  x2: "126%",
  y1: "26.385%",
  y2: "84.648%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "2%",
  stopColor: "#1E0D43"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "98%",
  stopColor: "#513292"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__d",
  x1: "96.212%",
  x2: "-6.819%",
  y1: "41.742%",
  y2: "56.569%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#070029"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#070029",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__g",
  x1: "21.287%",
  x2: "61.82%",
  y1: "-65.249%",
  y2: "97.555%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#106756"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "15%",
  stopColor: "#136C59"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "32%",
  stopColor: "#1C7B61"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "52%",
  stopColor: "#2A936F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "72%",
  stopColor: "#3DB481"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "74%",
  stopColor: "#40B984"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__h",
  x1: "28.699%",
  x2: "68.864%",
  y1: "67.174%",
  y2: "48.3%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "26%",
  stopColor: "#035748"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "62%",
  stopColor: "#0C6252"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#106756"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__k",
  x1: "64.969%",
  x2: "41.406%",
  y1: "7.299%",
  y2: "106.296%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "2%",
  stopColor: "#1E0D43"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "98%",
  stopColor: "#513292"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__l",
  x1: "-5.984%",
  x2: "88.715%",
  y1: "49.502%",
  y2: "50.075%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "34%",
  stopColor: "#E8ECF7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "45%",
  stopColor: "#E5E8F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "53%",
  stopColor: "#DCE1F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "59%",
  stopColor: "#D0D6ED"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__m",
  x1: "93.689%",
  x2: "24.788%",
  y1: "66.822%",
  y2: "40.28%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E8ECF7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "5%",
  stopColor: "#E6E9F6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "59%",
  stopColor: "#D5DBEE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#D0D6ED"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__n",
  x1: "0%",
  x2: "100.043%",
  y1: "50.017%",
  y2: "50.017%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "51%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__o",
  x1: "-5.619%",
  x2: "89.085%",
  y1: "49.511%",
  y2: "50.086%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "34%",
  stopColor: "#E8ECF7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "45%",
  stopColor: "#E5E8F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "53%",
  stopColor: "#DCE1F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "59%",
  stopColor: "#D0D6ED"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__p",
  x1: "26.635%",
  x2: "115.232%",
  y1: "32.604%",
  y2: "98.453%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#D0D6ED"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__q",
  x1: ".01%",
  x2: "100.048%",
  y1: "50.008%",
  y2: "50.008%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "51%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__r",
  x1: "19.649%",
  x2: "58.805%",
  y1: "23.17%",
  y2: "57.817%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#5C72B4",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__s",
  x1: "39.981%",
  x2: "63.688%",
  y1: "22.894%",
  y2: "91.281%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#77AFDF",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#77AFDF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__t",
  x1: "75.506%",
  x2: "21.569%",
  y1: "24.478%",
  y2: "75.123%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#77AFDF",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#77AFDF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__u",
  x1: "50.024%",
  x2: "49.963%",
  y1: "2.747%",
  y2: "122.16%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#94D1AD",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: "74%",
  stopColor: "#94D1AD",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__v",
  x1: "50.045%",
  x2: "49.969%",
  y1: "4.691%",
  y2: "81.943%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#EF789D",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#EF789D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__w",
  x1: "50.074%",
  x2: "49.831%",
  y1: "-15.576%",
  y2: "111.337%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#EF789D",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: "71%",
  stopColor: "#EF789D",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__x",
  x1: "50.093%",
  x2: "49.924%",
  y1: "5.465%",
  y2: "108.62%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#94D1AD",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: "73%",
  stopColor: "#94D1AD",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__y",
  x1: "-3.31%",
  x2: "85.682%",
  y1: "49.074%",
  y2: "50.145%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "34%",
  stopColor: "#E8ECF7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "45%",
  stopColor: "#E5E8F5"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "53%",
  stopColor: "#DCE1F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "59%",
  stopColor: "#D0D6ED"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__z",
  x1: "26.619%",
  x2: "115.216%",
  y1: "32.61%",
  y2: "98.457%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#D0D6ED"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__A",
  x1: "0%",
  x2: "100.014%",
  y1: "49.934%",
  y2: "49.934%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: "51%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__B",
  x1: "91.487%",
  x2: "24.538%",
  y1: "-50.416%",
  y2: "85.989%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#8E9DCF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "49%",
  stopColor: "#D0D6ED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#8E9DCF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__C",
  x1: "-12.484%",
  x2: "155.325%",
  y1: "-73.513%",
  y2: "258.928%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "3%",
  stopColor: "#F2F5FB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "23%",
  stopColor: "#EEF2FA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "44%",
  stopColor: "#DFE4F3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "63%",
  stopColor: "#D0D6ED"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__D",
  x1: "91.503%",
  x2: "24.554%",
  y1: "-50.406%",
  y2: "85.999%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#8E9DCF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "49%",
  stopColor: "#D0D6ED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#8E9DCF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__E",
  x1: "18.701%",
  x2: "115.399%",
  y1: "-19.73%",
  y2: "195.263%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "3%",
  stopColor: "#F2F5FB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "23%",
  stopColor: "#EEF2FA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "44%",
  stopColor: "#DFE4F3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "63%",
  stopColor: "#D0D6ED"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__F",
  x1: "91.484%",
  x2: "24.535%",
  y1: "-50.49%",
  y2: "85.879%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#8E9DCF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "49%",
  stopColor: "#D0D6ED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#8E9DCF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__G",
  x1: "-.195%",
  x2: "107.524%",
  y1: "-46.736%",
  y2: "160.753%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "3%",
  stopColor: "#F2F5FB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "23%",
  stopColor: "#EEF2FA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "44%",
  stopColor: "#DFE4F3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "63%",
  stopColor: "#D0D6ED"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__H",
  x1: "91.525%",
  x2: "24.576%",
  y1: "-50.34%",
  y2: "86.029%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#8E9DCF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "49%",
  stopColor: "#D0D6ED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#8E9DCF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "bootcamp101_svg__I",
  x1: "-12.664%",
  x2: "155.585%",
  y1: "-73.812%",
  y2: "259.108%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "3%",
  stopColor: "#F2F5FB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "23%",
  stopColor: "#EEF2FA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "44%",
  stopColor: "#DFE4F3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "63%",
  stopColor: "#D0D6ED"
})), /*#__PURE__*/React.createElement("path", {
  id: "bootcamp101_svg__e",
  d: "M26.9 16.2c.1 4.2-1.4 8.2-4.2 11.3-2.6 2.9-6.3 4.5-10.2 4.5h-.6c-2.7-.8-5.1-2.4-7-4.5-2.2-2.5-3.7-5.7-4.1-9-.1-.8-.2-1.7-.2-2.5C.5 7.1 7 0 15 .2h.6c5.7 1.7 10.1 7 11.1 13.6.1.7.2 1.6.2 2.4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "bootcamp101_svg__i",
  d: "M.3.3h40.3v39.8H.3z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__a)",
  fillRule: "nonzero",
  d: "M317.3 218.2l-107.7 62.3L340.1 356l107.7-62.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__b)",
  fillRule: "nonzero",
  d: "M172.2 90.7c-12.9-28.3-66.3-19.3-62.8-4.9 8.1 33.8-5.9 43.6-.6 68.5 5 23.4 19.7 28.9 26.8 34.3 17.1 12.9 44.2-13.9 51.9-35.9 7.2-20.6-8.3-46.6-15.3-62z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#221E33",
  fillRule: "nonzero",
  d: "M75.9 8.7c.4 0 .8.2 1.1.4 7.6 5.8 16.5 9.6 25.9 11 2.9.5 5.2 1 7 2 1.6.9 2.9 2.2 3.9 3.7 6.4-7.1 16.1-10.3 28.9-9.7l2.6.1c12.8.7 22.1 4.9 27.8 12.6 1.2-1.4 2.6-2.5 4.2-3.2 1.9-.8 4.2-1 7.2-1.3 9.5-.4 18.8-3.3 26.9-8.3.3-.2.7-.3 1.1-.3.4 0 .9.2 1.2.5.6.6.8 1.5.4 2.2-.4.7-1.7 3.8-2.1 4.6-1.7 3.7-7.5 11.5-9.1 20.9-.2.9-.4 2-.6 3l-5.6.5 4.2 3.5c-1.4 3.8-3.9 7.1-7 9.7l-6.2-3.6 2.1 5.9c-3.6 1.2-7.4 1.4-11.1.7.5 2.2.6 4.4.3 6.6-.5 3.2-2.3 6.1-5 7.9-3.7 2.7-9.5 4.5-17.7 5.4-1.5.4-2.8 1.3-3.5 2.7-.8 2.1-4.7 2.9-12.3 2.6h-.5c-4.4-.3-7.6-.8-9.5-1.7-1.6-.7-2.2-1.5-2.4-2.2-.6-1.4-1.7-2.6-3.2-3.1-8.4-1.9-14.2-4.4-17.6-7.6-2.4-2.3-3.8-5.5-3.7-8.8v-.2c.2-1.9.5-3.7.9-5.6-1.5.1-2.9.1-4.4 0l1-5.6-4 4.8-.3-3.3-2.6 2.5c-3.2-1.6-5.8-4-7.6-7.1l6.7-5.1-8.4 1.5c-1.1-2.4-1.7-5-2-7.7l3.8-1.7-4.1-.8 5.5-2.3-5.8-.2c-1.3-8.4-5.5-15.3-6.7-18.8-.3-.8-1.3-4-1.6-4.7-.1-.3-.2-.6-.2-.8.2-.9 1.1-1.7 2.1-1.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__c)",
  fillRule: "nonzero",
  d: "M75.9 8.7c.4 0 .8.2 1.1.4 7.6 5.8 16.5 9.6 25.9 11 2.9.5 5.2 1 7 2 1.6.9 2.9 2.2 3.9 3.7 6.4-7.1 16.1-10.3 28.9-9.7l2.6.1c12.8.7 22.1 4.9 27.8 12.6 1.2-1.4 2.6-2.5 4.2-3.2 1.9-.8 4.2-1 7.2-1.3 9.5-.4 18.8-3.3 26.9-8.3.3-.2.7-.3 1.1-.3.4 0 .9.2 1.2.5.6.6.8 1.5.4 2.2-.4.7-1.7 3.8-2.1 4.6-1.7 3.7-7.5 11.5-9.1 20.9-.2.9-.4 2-.6 3l-5.6.5 4.2 3.5c-1.4 3.8-3.9 7.1-7 9.7l-6.2-3.6 2.1 5.9c-3.6 1.2-7.4 1.4-11.1.7.5 2.2.6 4.4.3 6.6-.5 3.2-2.3 6.1-5 7.9-3.7 2.7-9.5 4.5-17.7 5.4-1.5.4-2.8 1.3-3.5 2.7-.8 2.1-4.7 2.9-12.3 2.6h-.5c-4.4-.3-7.6-.8-9.5-1.7-1.6-.7-2.2-1.5-2.4-2.2-.6-1.4-1.7-2.6-3.2-3.1-8.4-1.9-14.2-4.4-17.6-7.6-2.4-2.3-3.8-5.5-3.7-8.8v-.2c.2-1.9.5-3.7.9-5.6-1.5.1-2.9.1-4.4 0l1-5.6-4 4.8-.3-3.3-2.6 2.5c-3.2-1.6-5.8-4-7.6-7.1l6.7-5.1-8.4 1.5c-1.1-2.4-1.7-5-2-7.7l3.8-1.7-4.1-.8 5.5-2.3-5.8-.2c-1.3-8.4-5.5-15.3-6.7-18.8-.3-.8-1.3-4-1.6-4.7-.1-.3-.2-.6-.2-.8.2-.9 1.1-1.7 2.1-1.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#513292",
  fillRule: "nonzero",
  d: "M94.2 26.7c7.3 3.5 13 6.8 14.1 12.1 1.1 5.3-1.2 12.5-3 18.8l-.6 2.1c-1.5.2-2.9.2-4.4.1l1-5.6-4.1 4.8-.3-3.3-2.6 2.5c-3.2-1.6-5.8-4-7.6-7.1l6.7-5.1-8.4 1.5c-1.1-2.4-1.7-5-2-7.7l3.8-1.7-4.1-.8 5.5-2.3-5.8-.2c-1.3-8.4-5.5-15.3-6.7-18.8-.3-.8-1.3-4-1.6-4.7 5.4 8.5 12.8 11.9 20.1 15.4zm46.1-4.7c-1-.8-5.7-.4-5.7-.4-1.1.1-1.9.9-1.3 1.5 1.4 1 3.2 1.5 4.9 1.2 2.3-.5 3.1-1.6 2.1-2.3zm.1 4.4c-2.6 0-1.3 2.7.2 3.1 1.6.4 4-.3 3.8-1.3-.2-1-2.6-1.8-4-1.8zm8.5-4.5c-1.9-.3-4.4 1.6-4.6 2.5-.3 1.1 1.1 1.6 4.3 2.2 3.2.6 6.3-.8 6.4-1.7.1-.9-4.2-2.7-6.1-3zm28.3 20.5c1.3-2.7 2.8-6.6 11.6-9.3h.1c3.6-.9 7.1-2.1 10.5-3.7 5.5-2.8 10.4-6.5 14.7-10.9-.4.7-1.7 3.8-2.1 4.6-1.7 3.7-7.5 11.5-9.1 20.9-.2.9-.4 2-.6 3l-5.6.5 4.2 3.5c-1.4 3.8-3.9 7.1-7 9.7l-6.2-3.6 2.1 5.9c-2.7 1-5.6 1.6-11.1.7-.1-.7-.3-1.4-.4-2.1-1.6-6.1-3.6-14.3-1.1-19.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__d)",
  fillRule: "nonzero",
  d: "M117.7 59.1c.1 3 2.1 4.7 7.6 5h2.1c6-.1 8.6-.9 15.1-.6 6.5.3 9 1.3 15 1.9.7.1 1.4.1 2.1.2 5.5.2 7.6-1.3 8-4.3 4.4 3.9-1.7 9-6.2 11s-10.3 2.9-18.5 2.8l-1.8-.1c-8.1-.6-13.8-2-18.2-4.4-4.2-2.4-9.8-8-5.2-11.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M164.7 69.1c1.4-1.1 3.6-3 3.3-5.1 0-.1-.1-.1-.2-.1 0 0-.1 0-.1.1-1.1 1.5-2.8 2.4-4.7 2.6-.1 0-.1.1-.1.1v.1l1.5 2.3h.3zm-3.4 2.1c.8-.4 1.6-.8 2.3-1.3.1-.1.1-.2.1-.3l-1.6-2.5c0-.1-.1-.1-.2-.1 0 0-.1 0-.1.1l-.8 3.8c0 .2.1.3.3.3zm-1.5 0l.8-4c0-.2-.1-.4-.3-.5H159.5c-.7 0-1.5-.1-2.2-.2h-.2c-.2 0-.4.1-.4.4 0 .1 0 .2.1.3l2.8 4.1c0 .1.1.1.2 0v-.1zm-7 2.3c1.8-.2 3.6-.6 5.4-1.2.3-.1.4-.4.4-.7 0 0 0-.1-.1-.1-.9-1.2-2.8-4.1-3.3-4.9 0-.1-.1-.1-.2-.1l-.1.1-2.7 6.1c-.1.3 0 .6.3.7.1.1.2.1.3.1zm-1.9-.2l2.9-6.6c.1-.3 0-.6-.3-.7h-.1l-2.1-.3c-1.2-.2-2.5-.4-3.8-.6-.2 0-.4.1-.4.3v.2l3.6 7.7s.1.1.2 0zm-7 .8c1.8 0 3.5 0 5.1-.1.3 0 .5-.3.5-.6 0-.1 0-.1-.1-.2l-3.1-6.7c0-.1-.1-.1-.2-.1l-.1.1-2.7 6.8c-.1.3 0 .6.3.7.1 0 .2 0 .3.1zm-1.9-.7c0 .1.1.1.2.1 0 0 .1 0 .1-.1l3.1-7.9c.1-.3 0-.6-.3-.7h-.1c-.7-.1-1.5-.1-2.4-.2-.9 0-1.6-.1-2.4-.1-.3 0-.5.2-.5.5v.2l2.3 8.2zm-6.8-.1c1.6.2 3.3.4 5.1.6.3 0 .6-.2.6-.5v-.2l-2.1-7c0-.1-.1-.1-.2-.1 0 0-.1 0-.1.1l-3.7 6.4c-.1.3-.1.6.2.7.1 0 .2.1.2 0zm-1.7-.8l4.3-7.3c.1-.2 0-.4-.2-.6-.1 0-.1-.1-.2-.1-1.4.1-2.6.1-3.9.2l-2.3.2c-.2 0-.4.2-.4.4v.1l2.3 6.9c.2.2.3.3.4.2zm-7.3-1.6c1.7.7 3.5 1.3 5.3 1.7.3.1.6-.1.6-.4v-.3l-2.2-6.3c0-.1-.1-.1-.2-.1l-.1.1-3.7 4.6c-.2.2-.2.6.1.7h.2zm-2-5.3l.5 4.1c0 .1.1.1.1.1s.1 0 .1-.1l3.2-3.9c.1-.2.1-.4-.1-.6-.1-.1-.2-.1-.3-.1H124.6c-.2.1-.4.2-.4.5zm-3.1 2.4l2.1 1.5c.2.1.3 0 .3-.2l-.4-3.8c0-.1-.1-.1-.1-.1s-.1 0-.1.1l-1.8 2.4c-.2-.1-.2.1 0 .1-.1 0-.1 0 0 0zm-1.9-1.7l.8.8c0 .1.1.1.2 0l1.7-2.2v-.2h-.1c-1-.2-2-.6-2.9-1.2-.7-.4-1.2-1-1.6-1.7 0-.1-.1-.1-.2-.1 0 0-.1 0-.1.1 0 .2-.1.5-.1.7.4 1.5 1.1 2.8 2.3 3.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#513292",
  fillRule: "nonzero",
  d: "M170.4 43.1c-4.4-.3-10 4.3-18.5 7.3-3.1 1-6.4 1.9-6.9 2-.5.1 2.9.5 4.9.8 1.7 3.2 5 5.2 8.6 5.2 5.8.2 8.8-3.2 9.6-6.9.3-1 .3-2.1.3-3.1 0 0-2.5-.5-8 .5 3.4-1.5 6.3-2.7 8.8-2.7 1.5 0 3 .3 4.4.8.1 0-.5-3.7-3.2-3.9zm-54.8.8c2.5.2 5.3 1.6 8.6 3.4-5.4-1.4-7.9-1.2-7.9-1.2-.2 1-.2 2.1 0 3.1.5 3.8 3.2 7.5 9 7.8 3.6.3 7.1-1.4 9-4.5 2-.1 5.4-.2 4.9-.4s-3.7-1.2-6.7-2.6c-8.2-3.6-13.4-8.8-17.8-8.8-2.6 0-3.5 3.6-3.5 3.6 1.3-.4 2.8-.5 4.4-.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#40B883",
  fillRule: "nonzero",
  d: "M124.2 47.3c-5.4-1.5-7.9-1.2-7.9-1.2-.2 1-.2 2.1 0 3.1.5 3.8 3.2 7.5 8.9 7.8 3.6.3 7.1-1.4 9-4.5-3.5-1.4-6.9-3.1-10-5.2zm25.8 5.9c1.7 3.2 5 5.2 8.6 5.2 5.8.2 8.7-3.2 9.6-6.9.2-1 .4-2.1.3-3.1 0 0-2.5-.5-8 .5-3.4 1.7-6.9 3.2-10.5 4.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7ECAAA",
  fillRule: "nonzero",
  d: "M153.4 54.5c-.2-1.7 8.9-3.5 8.9-3.5 2.9-.9 2.6.9 2.1 1.8s-2.4 4.1-5.1 4.4c-2.7.3-5.7-1.5-5.9-2.7zm-33.8-3.6c.4 1 2 4.1 4.7 4.8 2.7.7 5.6-.6 6-2.2.4-1.6-8.5-4.2-8.5-4.2-1.2-.4-3.2-.8-2.2 1.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M156.9 52.6s-2.9.6-3.1 1.9c-.2 1.3 4.4-1.3 5.5-1.7 1.1-.4.1-.9-2.4-.2zm-29.7-1.3s2.9.9 2.9 2.2c0 1.3-4.2-1.7-5.3-2.2-1.1-.5 0-.9 2.4 0z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(156 31)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "bootcamp101_svg__f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bootcamp101_svg__e"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  mask: "url(#bootcamp101_svg__f)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#513292",
  d: "M29.8 2c-5.1.4-10.8 3.2-17.5 7 11-3 16.2-2.5 16.2-2.5.3 2.1.3 4.3-.1 6.4-1.1 7.7-6.5 15.4-18.3 15.8-7.4.6-14.5-2.9-18.5-9.1-4-.3-11.1-.4-10.1-.8 1-.3 7.5-2.5 13.6-5.2C11.9 6.2 22.5-4.3 31.5-4.5c5.4-.1 7.2 7.4 7.2 7.4-2.9-.8-5.9-1.1-8.9-.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#40B883",
  d: "M12.2 9.1c11-3 16.2-2.5 16.2-2.5.3 2.1.3 4.3-.1 6.4-1.1 7.7-6.4 15.3-18.3 15.9-7.4.6-14.5-2.9-18.5-9.1 7.3-2.9 14.2-6.5 20.7-10.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7ECAAA",
  d: "M21.4 16.5c-.9 2-4.1 8.4-9.7 9.8C6.1 27.7.2 25.2-.6 21.9c-.8-3.3 17.4-8.7 17.4-8.7 2.6-.8 6.9-1.6 4.6 3.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M6.1 17.3S.2 19 .2 21.8c0 2.7 8.6-3.5 10.8-4.5 2.2-1.1 0-1.9-4.9 0z"
}))), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__g)",
  fillRule: "nonzero",
  d: "M175.5 65.7l4.7-1.9 9 21.9-4.8 2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#106756",
  fillRule: "nonzero",
  d: "M182.7 44.4c.1.8.2 1.7.2 2.5.1 4.2-1.4 8.2-4.2 11.3-2.6 2.9-6.3 4.6-10.2 4.5-4-.2-7.7-2-10.3-5-2.2-2.5-3.6-5.7-4.1-9-.1-.8-.2-1.7-.2-2.5 0-8.9 6.4-16 14.4-15.8 7.2.2 13.3 6.3 14.4 14.1m-33.4 4.9c.6 4.4 2.6 8.6 5.5 12 3.4 4 8.4 6.5 13.7 6.7 10.7.3 19.3-9.1 19.2-21 0-1.1-.1-2.2-.2-3.3-1.5-10.3-9.6-18.5-19.2-18.8-10.7-.3-19.3 9.1-19.2 21-.1 1.1 0 2.2.2 3.4"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#40B984",
  fillRule: "nonzero",
  d: "M185.5 44.9c.1.8.2 1.7.2 2.5.1 4.2-1.4 8.2-4.2 11.3-2.6 2.9-6.3 4.6-10.2 4.5-4-.2-7.7-2-10.3-5-2.2-2.5-3.6-5.7-4.1-9-.1-.8-.2-1.7-.2-2.5-.1-8.9 6.4-16 14.4-15.8 7.2.2 13.3 6.3 14.4 14m-33.4 5c.6 4.4 2.5 8.6 5.5 12 3.4 4 8.4 6.5 13.7 6.7 10.7.3 19.3-9.1 19.2-21 0-1.1-.1-2.2-.2-3.3-1.5-10.3-9.6-18.4-19.2-18.7-10.7-.3-19.3 9.1-19.2 21-.1 1 0 2.2.2 3.3"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1E8CCC",
  fillRule: "nonzero",
  d: "M169.4 35c-5.1 2.3-8.3 6.9-9 13.6-1-6.7 3.1-12.7 9-13.6m-12.6 14.2c.5 3.3 1.9 6.5 4.1 9 2.6 3 6.3 4.8 10.3 5 3.9.1 7.6-1.5 10.2-4.4 2.8-3.1 4.3-7.2 4.2-11.3 0-.8-.1-1.7-.2-2.5-1.1-7.8-7.2-13.9-14.4-14.1-8-.2-14.5 6.8-14.4 15.8 0 .8.1 1.6.2 2.5",
  opacity: 0.45
}), /*#__PURE__*/React.createElement("path", {
  fill: "#92BAE3",
  fillRule: "nonzero",
  d: "M161.1 49c0-6.7 2.8-11.6 7.6-14.5-5.9 1.5-9.3 8-7.6 14.5",
  opacity: 0.7
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__h)",
  fillRule: "nonzero",
  d: "M181.7 74.1c-2.1.8-3.6 1.9-3.4 2.3l5.2 12.8h8.7l-6.5-15.9c-.2-.4-2-.1-4 .8z"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(166 68)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "bootcamp101_svg__j",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bootcamp101_svg__i"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#1E0D43",
  fillRule: "nonzero",
  d: "M41.1 33.8s-3.8-21-11.5-26.2c-7.7-5.2-21.3 5.6-21.3 5.6l8.2 2.3-8.8 7.7 9.3.9-3.5 11.4 12-5.9S20.4 44 31.4 46.7c11 2.7 9.7-12.9 9.7-12.9z",
  mask: "url(#bootcamp101_svg__j)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__k)",
  fillRule: "nonzero",
  d: "M110.2 75.9c30.4 14.1-1 45.5-1 45.5s21.7-7.3 30.6-2.7c8.9 4.6 5.7 22.9 5.7 22.9l-6.4-6.5-2.7 12.2-5.7-8.3-8.9 9.2-.7-14.3s-25.2 22.2-33.5 13.2 1-81.2 22.6-71.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__l)",
  fillRule: "nonzero",
  d: "M219.3 237.5l-96.7-57.6v47.5c0 2.2 1.2 4.2 3.1 5.3l93.6 54.2c5.7 3.2 12.7 3.2 18.3 0l92.8-53.8c1.9-1.1 3.1-3.1 3.1-5.3V180l-95.9 57.6c-5.6 3.1-12.6 3.1-18.3-.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__m)",
  fillRule: "nonzero",
  d: "M219.3 237.5l-95.1-54.9c-1.5-.8-2-2.6-1.2-4.1.3-.5.7-.9 1.2-1.2l94.3-54.5c5.7-3.2 12.7-3.2 18.3 0l95.2 54.9c1.5.8 2 2.6 1.2 4.1-.3.5-.7.9-1.2 1.2l-94.4 54.5c-5.6 3.2-12.6 3.2-18.3 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__n)",
  fillRule: "nonzero",
  d: "M228.5 241.5c-3.5 0-7-.9-10-2.7l-95.2-54.9 1.6-2.8 95.2 54.9c5.2 3 11.6 3 16.7 0l94.4-54.5 1.6 2.8-94.4 54.5c-3 1.8-6.4 2.7-9.9 2.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C72B4",
  fillRule: "nonzero",
  d: "M239.9 266l87-50.2v-4.1l-87 50.2v4.1zm0-6.8l87-50.2v-4.1l-87 50.2v4.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__o)",
  fillRule: "nonzero",
  d: "M219.2 183.6L122.5 126v47.5c0 2.2 1.2 4.2 3.1 5.3l93.6 54.1c5.7 3.2 12.7 3.2 18.3 0l92.8-53.8c1.9-1.1 3.1-3.1 3.1-5.3V126l-95.9 57.6c-5.6 3.2-12.6 3.2-18.3 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__p)",
  fillRule: "nonzero",
  d: "M219.2 183.6L124 128.7c-1.5-.8-2-2.6-1.2-4.1.3-.5.7-.9 1.2-1.2l94.4-54.5c5.7-3.2 12.7-3.2 18.3 0l95.2 54.9c1.5.8 2 2.6 1.2 4.1-.3.5-.7.9-1.2 1.2l-94.4 54.5c-5.6 3.2-12.6 3.2-18.3 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__q)",
  fillRule: "nonzero",
  d: "M228.4 187.6c-3.5 0-7-.9-10-2.7L123.2 130l1.6-2.8 95.2 54.9c5.2 3 11.6 3 16.7 0l94.4-54.5 1.6 2.8-94.4 54.5c-2.9 1.8-6.4 2.7-9.9 2.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#5C72B4",
  fillRule: "nonzero",
  d: "M239.8 212.1l87-50.2v-4.1l-87 50.2v4.1zm0-6.8l87-50.2V151l-87 50.2v4.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__r)",
  fillRule: "nonzero",
  d: "M203 294.4L95.3 356.7l130.6 75.5L333.6 370z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D0D6ED",
  fillRule: "nonzero",
  d: "M280.6 102.4l-103.9 60-9.2-5.3 103.9-60z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__s)",
  fillRule: "nonzero",
  d: "M186 46l76-43.9c6-3.5 10.9.2 10.9 8.2v94.5l-97.7 56.4V66.7c0-7.9 4.8-17.3 10.8-20.7z",
  opacity: 0.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__t)",
  fillRule: "nonzero",
  d: "M188.8 47.4l76-43.9c6-3.5 10.9.2 10.9 8.2v93.7L178 161.8V68.2c0-8.1 4.8-17.4 10.8-20.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__u)",
  fillRule: "nonzero",
  d: "M260.2 58.4l9.4-5.5v51l-9.4 5.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__v)",
  fillRule: "nonzero",
  d: "M247.8 89.2l9.4-5.5V111l-9.4 5.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__w)",
  fillRule: "nonzero",
  d: "M244 117.8l-12-46.1-8.4 1.9-6.3 10.4-12.8-23.6-13.4 1.2-3.9 2.3v86.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__x)",
  fillRule: "nonzero",
  d: "M242.2 69.2l-8.6-24.3-11.5 2.4-9 62.5-12 6.9-7.6-17.3-8-.9v53.2l56.7-34.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__y)",
  fillRule: "nonzero",
  d: "M96.9 200.3L.2 142.7v155.6c0 2.2 1.2 4.2 3.1 5.3L97 357.8c5.7 3.2 12.7 3.2 18.3 0l92.8-53.8c1.9-1.1 3.1-3.1 3.1-5.3v-156l-95.9 57.6c-5.7 3.3-12.7 3.3-18.4 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__z)",
  fillRule: "nonzero",
  d: "M96.9 200.3L1.7 145.4c-1.5-.8-2-2.6-1.2-4.1.3-.5.7-.9 1.2-1.2l94.4-54.5c5.7-3.2 12.7-3.2 18.3 0l95.2 54.9c1.5.8 2 2.6 1.2 4.1-.3.5-.7.9-1.2 1.2l-94.4 54.5c-5.6 3.2-12.6 3.2-18.3 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#D0D6ED",
  fillRule: "nonzero",
  d: "M106.1 185.5c-2.7 0-5.3-.7-7.6-2l-60-34.7c-3.4-2-4.6-6.3-2.6-9.7.6-1.1 1.5-2 2.6-2.6l59.2-34.2c4.7-2.8 10.6-2.8 15.3 0l60 34.6c3.4 2 4.6 6.3 2.6 9.7-.6 1.1-1.5 2-2.6 2.6l-59.2 34.2c-2.4 1.5-5 2.2-7.7 2.1zm-64.6-43.6c-.5.3-.6 1-.3 1.5l.3.3 60 34.7c2.8 1.6 6.3 1.6 9.2 0l59.2-34.2c.3-.2.5-.5.5-.9s-.2-.7-.5-.9l-60-34.7c-2.8-1.6-6.3-1.6-9.2 0l-59.2 34.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__A)",
  fillRule: "nonzero",
  d: "M106.1 204.4c-3.5 0-7-.9-10-2.7L.9 146.8l1.6-2.8 95.2 54.9c5.2 3 11.6 3 16.7 0l94.4-54.5 1.6 2.8-94.4 54.5c-3 1.8-6.4 2.7-9.9 2.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__B)",
  fillRule: "nonzero",
  d: "M136.4 236c0-5.5 3.9-12.2 8.7-14.9 2.5-1.5 4.8-1.5 6.4-.5l10.1 5.8-12.1 21.2-10.6-6c-1.5-.9-2.5-2.8-2.5-5.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__C)",
  fillRule: "nonzero",
  d: "M146.9 242c0 5.5 3.9 7.7 8.7 4.9 4.8-2.8 8.7-9.4 8.7-14.9s-3.9-7.7-8.7-4.9c-4.8 2.8-8.7 9.4-8.7 14.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__D)",
  fillRule: "nonzero",
  d: "M168.2 258c0-5.5 3.9-12.2 8.7-14.9 2.5-1.5 4.8-1.5 6.4-.5l10.1 5.8-12.1 21.2-10.6-6c-1.4-.9-2.5-2.8-2.5-5.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__E)",
  fillRule: "nonzero",
  d: "M178.7 264c0 5.5 3.9 7.7 8.7 5 4.8-2.7 8.7-9.4 8.7-14.9s-3.9-7.7-8.7-4.9c-4.8 2.8-8.7 9.3-8.7 14.8z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__F)",
  fillRule: "nonzero",
  d: "M136.4 276.6c0-5.5 3.9-12.2 8.7-14.9 2.5-1.5 4.8-1.5 6.4-.5l10.1 5.8-12.1 21.2-10.6-6c-1.5-.9-2.5-2.9-2.5-5.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__G)",
  fillRule: "nonzero",
  d: "M146.9 282.6c0 5.5 3.9 7.7 8.7 5 4.8-2.7 8.7-9.4 8.7-14.9s-3.9-7.7-8.7-5c-4.8 2.7-8.7 9.4-8.7 14.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2B357E",
  fillRule: "nonzero",
  d: "M30.5 213.1v-18.3L20 188.6v18.3l10.5 6.2zm15.7 9.1v-18.3l-10.5-6.2V216l10.5 6.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E5335B",
  fillRule: "nonzero",
  d: "M62 231.3V213l-10.6-6.2V225z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2B357E",
  fillRule: "nonzero",
  d: "M77.7 240.3V222l-10.5-6.3V234z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F8AC1C",
  fillRule: "nonzero",
  d: "M30.5 237.4v-18.3L20 212.9v18.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2B357E",
  fillRule: "nonzero",
  d: "M46.2 246.5v-18.3L35.6 222v18.3l10.6 6.2zm15.8 9.1v-18.3L51.4 231v18.3l10.6 6.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F8AC1C",
  fillRule: "nonzero",
  d: "M77.7 264.6v-18.3l-10.5-6.2v18.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2B357E",
  fillRule: "nonzero",
  d: "M30.5 261.8v-18.3L20 237.3v18.3l10.5 6.2zm15.7 9.1v-18.3l-10.5-6.2v18.3l10.5 6.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F8AC1C",
  fillRule: "nonzero",
  d: "M62 280v-18.3l-10.6-6.2v18.4z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#2B357E",
  fillRule: "nonzero",
  d: "M77.7 289v-18.2l-10.5-6.3v18.3l10.5 6.2zm-47.2-2.9v-18.4l-10.6-6.2v18.3l10.6 6.3zm15.7 9.1v-18.3l-10.6-6.2V289l10.6 6.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#E5335B",
  fillRule: "nonzero",
  d: "M62 304.3V286l-10.6-6.2v18.3l10.6 6.2zm15.7 9v-18.2l-10.5-6.2v18.3l10.5 6.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__H)",
  fillRule: "nonzero",
  d: "M168.2 217.4c0-5.5 3.9-12.2 8.7-14.9 2.5-1.5 4.8-1.5 6.4-.5l10.1 5.8-12.1 21.2-10.6-6c-1.5-.9-2.5-2.8-2.5-5.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#bootcamp101_svg__I)",
  fillRule: "nonzero",
  d: "M178.7 223.4c0 5.5 3.9 7.7 8.7 5 4.8-2.7 8.7-9.4 8.7-14.9s-3.9-7.7-8.7-5c-4.8 2.7-8.7 9.4-8.7 14.9z"
}));

function SvgBootcamp101(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 415 418"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/bootcamp101.7d0e3197.svg";
export { SvgBootcamp101 as ReactComponent };